// :cow: Cosmose CONFIDENTIAL :iso:
import { Directive, EmbeddedViewRef, Input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[coaRepeatElement]',
})
export class RepeatElementDirective implements OnChanges {

  @Input() coaRepeatElement: number;
  private createdViews: EmbeddedViewRef<any>[] = [];

  constructor(
    private view: ViewContainerRef,
    private template: TemplateRef<any>,
  ) {
  }

  ngOnChanges(): void {
    this.destroyViews();
    for (let i = 0; i < this.coaRepeatElement; i++) {
      const view = this.view.createEmbeddedView(this.template);
      this.createdViews.push(view);
    }
  }

  private destroyViews(): void {
    this.createdViews.forEach(view => view.destroy());
    this.createdViews = [];
  }
}
